export const KIND_LABEL = {
  appointment: 'Cita previa',
  incident: 'Incidencia',
  suggestion: 'Sugerencia',
}

export const STATUS_LABEL = {
  pending: 'Pendiente',
  in_progress: 'En trámite',
  resolved: 'Resuelta',
  cancelled: 'Cancelada',
}

/** Labels de estado orientados a citas (mismo enum backend). */
export const CITA_STATUS_LABEL = {
  pending: 'Pendiente',
  in_progress: 'Confirmada',
  resolved: 'Completada',
  cancelled: 'Cancelada',
}

export const INCIDENT_CATEGORIES = [
  'calzada',
  'alumbrado',
  'residuos',
  'parques',
  'otro',
  'sugerencia',
]

export const MUNICIPALITY_OPTIONS = [
  'Ejea de los Caballeros',
  'Sos del Rey Católico',
  'Uncastillo',
  'Sádaba',
  'Tauste',
  'Luesia',
  'Asín',
]

export function siteNamesFromSites(sites) {
  if (!Array.isArray(sites)) return []
  return sites
    .map((raw) => {
      if (typeof raw === 'string') return raw.trim()
      return String(raw?.name || '').trim()
    })
    .filter(Boolean)
}

export function listPathForKind(kind) {
  if (kind === 'appointment') return '/citas'
  if (kind === 'suggestion') return '/sugerencias'
  return '/incidencias'
}

export function editPathForKind(kind, id) {
  const base =
    kind === 'appointment' ? '/edit-cita'
    : kind === 'suggestion' ? '/edit-sugerencia'
    : '/edit-incidencia'
  return id ? `${base}/${id}` : base
}

export function mapCitasRows(tickets) {
  return tickets.map((t) => ({
    id: t._id,
    ref: t.ref || '—',
    serviceName: t.serviceName || '—',
    site: t.site || '—',
    municipality: t.municipality || '—',
    dateTime: [t.date, t.time].filter(Boolean).join(' ') || '—',
    date: t.date || '',
    status: CITA_STATUS_LABEL[t.status] || t.status,
    statusRaw: t.status,
    email: t.email || '—',
    fullName: t.fullName || '',
    createdAt: t.createdAt,
    _raw: t,
  }))
}

export function mapIncidenciasRows(tickets) {
  return tickets.map((t) => {
    const hasLocation =
      (t.lat != null && t.lng != null) ||
      (typeof t.notes === 'string' && /coords:/i.test(t.notes))
    return {
      id: t._id,
      ref: t.ref || '—',
      kind: KIND_LABEL[t.kind] || t.kind,
      title: t.title || '—',
      category: t.category || '—',
      municipality: t.municipality || '—',
      location: hasLocation ? 'Sí' : '—',
      status: STATUS_LABEL[t.status] || t.status,
      email: t.email || '—',
      fullName: t.fullName || '',
      createdAt: t.createdAt,
      _raw: t,
    }
  })
}

function matchesSearch(ticket, search) {
  const q = (search || '').trim().toLowerCase()
  if (!q) return true
  const hay = [
    ticket.ref,
    ticket.email,
    ticket.fullName,
    ticket.title,
    ticket.serviceName,
    ticket.site,
    ticket.municipality,
    ticket.description,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase()
  return hay.includes(q)
}

export function filterCitasTickets(tickets, { municipality, service, dateFrom, dateTo, search }) {
  return tickets.filter((t) => {
    if (municipality && (t.municipality || '') !== municipality) return false
    if (service) {
      const s = service.trim().toLowerCase()
      if (!(t.serviceName || '').toLowerCase().includes(s)) return false
    }
    if (dateFrom && (t.date || '') < dateFrom) return false
    if (dateTo && (t.date || '') > dateTo) return false
    if (!matchesSearch(t, search)) return false
    return true
  })
}

export function filterIncidenciasTickets(tickets, { municipality, category, dateFrom, dateTo, search }) {
  return tickets.filter((t) => {
    if (municipality && (t.municipality || '') !== municipality) return false
    if (category && (t.category || '') !== category) return false
    const created = t.createdAt ? String(t.createdAt).slice(0, 10) : ''
    if (dateFrom && created && created < dateFrom) return false
    if (dateTo && created && created > dateTo) return false
    if (!matchesSearch(t, search)) return false
    return true
  })
}

export function mapSugerenciasRows(tickets) {
  return tickets.map((t) => ({
    id: t._id,
    ref: t.ref || '—',
    title: t.title || '—',
    status: STATUS_LABEL[t.status] || t.status,
    statusRaw: t.status,
    email: t.email || '—',
    fullName: t.fullName || '',
    createdAt: t.createdAt,
    _raw: t,
  }))
}

export function filterSugerenciasTickets(tickets, { dateFrom, dateTo, search }) {
  return tickets.filter((t) => {
    const created = t.createdAt ? String(t.createdAt).slice(0, 10) : ''
    if (dateFrom && created && created < dateFrom) return false
    if (dateTo && created && created > dateTo) return false
    if (!matchesSearch(t, search)) return false
    return true
  })
}
